import { getData, postData } from '../plugins/ApiCalls'

export function fetchHiddenFields(formId, variantId) {
  return getData('forms/' + formId + '/variants/' + variantId + '/hiddenFields')
}

export function saveHiddenFields(formId, variantId, hiddenFields) {
  return postData('forms/' + formId + '/variants/' + variantId + '/hiddenFields', { hiddenFields: hiddenFields }, { emulateJSON: true })
}
